export class JobProgressStepSnapshotCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "reEncrypted",
            "baseName": "reEncrypted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "usedCustomerManagedKey",
            "baseName": "usedCustomerManagedKey",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "allocatedStorageGib",
            "baseName": "allocatedStorageGib",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludedVolumeCount",
            "baseName": "excludedVolumeCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "string",
            "format": ""
        },
        {
            "name": "reEncryptionReason",
            "baseName": "reEncryptionReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "artifactName",
            "baseName": "artifactName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<JobProgressStepSnapshotCreationDataVolumesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepSnapshotCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
